exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container--2g1Ot{display:flex;flex-direction:column;position:absolute;top:16px;left:16px;padding:16px;background-color:#fff;box-shadow:0 16px 32px rgba(101,115,129,.24);border-radius:4px;z-index:450}.row--37yYf{display:flex;align-items:center}.row--37yYf:first-child{margin-bottom:15px}.icon--cPgvr{margin-right:18px;font-size:20px;color:rgba(0,0,0,.6)}", ""]);

// Exports
exports.locals = {
	"container": "container--2g1Ot",
	"row": "row--37yYf",
	"icon": "icon--cPgvr"
};